"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    borrowerConfig: finley_types_1.Organization.BorrowerConfigSchema.describe('Borrower config'),
    creditFacilityConfigs: zod_1.z
        .array(finley_types_1.Organization.CreditFacilityConfigWithSlugSchema)
        .describe('Credit facility configs'),
});
exports.nodeType = 'file_configTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'configTape';
//# sourceMappingURL=types.js.map